// Office401kHistoryReport.ts
// Event handler for Office Payroll 401k History report layout

// Update the import path if the file exists elsewhere, for example:
import { AutogenLayoutOffice401kHistoryReport } from "./autogen/AutogenLayoutOffice401kHistoryReport";
// Or ensure that '../../reports/autogen/AutogenLayoutOffice401kHistoryReport.ts' exists and is correctly named.

export class Office401kHistoryReport extends AutogenLayoutOffice401kHistoryReport {

    onLoad() {
        // Initialize report with detail view selected by default
        if (this.switchReportType) {
            this.switchReportType.checked = true; // Detail report by default (right side)
        }
    }

    /** Event handler for report type switch changes */
    reportTypeChanged() {
        const isDetailed = this.switchReportType ? this.switchReportType.checked : true;

        // Both summary and detail reports can include settlement history
        // No specific logic needed to disable controls based on report type
        if (this.checkboxIncludeSettlemt) {
            // Keep settlement history checkbox available for both report types
        }
    }

    checkboxIncludeSettlemtOnChange() {
        this.excludabletextboxPayeeId.textbox.clear();
        if(this.checkboxIncludeSettlemt.checked) {
            this.excludabletextboxPayeeId.textbox.lookupModel = "lme/settlement/transfer-to-settlement-payee";
            this.excludabletextboxPayeeId.textbox.lookupModelLayout = "lme/settlement/TransferToSettlementPayeeLookup";
        }
        else {
            this.excludabletextboxPayeeId.textbox.lookupModel = "lme/settlement/officepayroll/off-payee";
            this.excludabletextboxPayeeId.textbox.lookupModelLayout = "lme/settlement/officepayroll/OfficePayeeLookup";
        }
    }
}
